export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('./tasks-list.html'),
        controller: tasksListController,
        controllerAs: 'tasks'
    };
}

function tasksListController(getTasks, $state, completeTask, takeTaskOwnership, takeOverTaskOwnership, currentUser, applyTaskOwnershipState) {
    const vm = this;
    const dailyTaskId = 700;

    /* --- */

    vm.loading = false;
    vm.list = [];
    vm.notDisplayDailyOnly = false;
    vm.currentUserName = '';

    /* --- */

    vm.loadMoreTasks = requestTasks;
    vm.openTask = openTask;
    vm.completeTask = complete;
    vm.openVehicle = openVehicle;
    vm.notDisplayDailyOnlyChanged = notDisplayDailyOnlyChanged;
    vm.displayTasksOwnedByUserChanged = displayTasksOwnedByUserChanged;
    vm.takeOwnership = takeOwnership;
    vm.takeOverOwnership = takeOverOwnership;

    /* --- */

    let pageNumber = 0;
    let hasMoreData;

    /* --- */

    resetTasks();

    /* --- */

    currentUser()
        .then(result => {
            vm.currentUserName = result.name;
        });

    function resetTasks() {
        hasMoreData = true;
        vm.list = [];
        pageNumber = 0;
        requestTasks();
    }

    function requestTasks() {
        if (hasMoreData === false || vm.loading === true) {
            return;
        }

        vm.loading = true;

        pageNumber++;

        const requestParams = {};

        if (vm.notDisplayDailyOnly) {
            requestParams.taskType = dailyTaskId;
        }

        if (vm.displayTasksOwnedByUser) {
            requestParams.ownedBy = vm.currentUserName;
        }

        getTasks(pageNumber, requestParams).then(result => {
            vm.loading = false;
            vm.list = vm.list.concat(result.tasks);

            hasMoreData = result.hasMoreData;
        });
    }

    function openTask(task) {
        const [stateName, stateParams] = getStateCallArgs(task.source.linkType, task.source.link);
        $state.go(stateName, stateParams);
    }

    function complete(task) {
        completeTask(task.id)
        .then(resetTasks);
    }

    function openVehicle(task) {
        $state.go('tasks.vehicles.details', {
            vrm: task.vrm
        });
    }

    function notDisplayDailyOnlyChanged() {
        resetTasks();
    }

    function displayTasksOwnedByUserChanged() {
        resetTasks();
    }

    function takeOwnership(task) {
        takeTaskOwnership(task)
        .then(() => {
            task.ownedBy = vm.currentUserName;
            return applyTaskOwnershipState(task, vm.currentUserName);
        });
    }

    function takeOverOwnership(task) {
        takeOverTaskOwnership(task)
        .then(() => {
            task.ownedBy = vm.currentUserName;
            return applyTaskOwnershipState(task, vm.currentUserName);
        });
    }
}

const stateResolver = {
    vehicle: id => ['enquiries.details', {vehicleId: id}],
    Export: id => ['data-import-export.import.list', {exportId: id}],
    EnquiryImport: id => {
        if (id.indexOf(':') >= 0) {
            const importId = id.substring(0, id.indexOf(':'));
            return ['data-import-export.import.detail', {importId}];
        }
        return ['data-import-export.import.list'];
    },
    Vehicle: id => ['enquiries.details', {vehicleId: id}],
    NoLink: () => ['tasks.nolink'],
    OldWebsiteResponseImport: id => {
        if (id.indexOf(':') >= 0) {
            const importId = id.substring(0, id.indexOf(':'));
            return ['data-import-export.import.detail', {importId}];
        }
        return ['data-import-export.import.list'];
    },
    EliseImport: id => ['tasks.nolink']
};

function getStateCallArgs(taskType, id) {
    if (typeof stateResolver[taskType] === 'function') {
        return stateResolver[taskType](id);
    }

    throw new Error(`task type: ${taskType} is not handled`);
}



// WEBPACK FOOTER //
// ./Client/app/tasks/directives/tasksList/index.js